import { atomWithStorage } from 'jotai/utils';

const isLight = window?.matchMedia?.('(prefers-color-scheme: light)')?.matches;
export const themeAtom = atomWithStorage<'light' | 'dark'>(
  'persist:color-mode',
  isLight !== undefined && isLight ? 'light' : 'dark',
);
